import { gql } from '__generated__';

export default gql(`
  mutation EditCoupon($input: EditCouponInput!) {
    editCoupon(input: $input) {
      ...CouponFields
    }
  }
`);
